import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  LobsterMasterApi,
  type PostInternalLabelCopyAreasRequestBody,
} from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { getLobsterApiErrorDetail } from './getLobsterApiErrorDetail'
import { labelMasterQueryKeys } from './queryKeys'

export const useCopyLabelAreas = () => {
  const queryClient = useQueryClient()
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (data: PostInternalLabelCopyAreasRequestBody) =>
      baseClient.getApi(LobsterMasterApi).postInternalLabelCopyAreas({
        postInternalLabelCopyAreasRequestBody: data,
      }),
    onSuccess: () => {
      showSuccessSnackbar('検査箇所のペーストに成功しました')
      queryClient.invalidateQueries({
        queryKey: labelMasterQueryKeys.labels.all,
      })
    },
    onError: async error => {
      const detail = await getLobsterApiErrorDetail(error)
      showErrorSnackbar(
        detail ??
          '検査箇所のペーストに失敗しました。しばらく経ってから再度お試しください。',
      )
    },
  })
}
